import './Basiccomponents.css'
import React from 'react'
import TitleSection from '../TitleSection/TitleSection'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faStar, faImages, faEnvelope, faHandPointer } from '@fortawesome/free-solid-svg-icons';
import img2 from '../img/unnamed.png'
import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

const FeatureBox = ({ icon, title, description, delay }) => {
  const [ref, inView] = useInView({ triggerOnce: true });

  return (
    <motion.div
      ref={ref}
      className='features-box text-end'
      initial={{ opacity: 0, y: 50 }}
      animate={inView ? { opacity: 1, y: 0 } : {}}
      transition={{ duration: 1, delay }}
    >
      <div className='features-icon float-end ms-2'>
        <FontAwesomeIcon icon={icon} className="coloricon" />
      </div>
      <div className='pe-3 me-5'>
        <h5 className='boxh5'>{title}</h5>
        <p className='mt-3 boxp'>{description}</p>
      </div>
    </motion.div>
  );
};

function Basiccomponents() {
  const [refImg, inViewImg] = useInView({ triggerOnce: true });

  return (
    <div className='basiccomponents' id='basiccomponentsid'>
      <div className="container">
        <TitleSection title="المكونات الأساسية للمواقع الإلكترونية" />
        <div className="row justify-content-center align-items-center">
          <div className='col-lg-4 col-md-10 p-12'>
            <FeatureBox
              icon={faStar}
              title='تصميم واجهة جذابة'
              description='يجب أن تكون الواجهة واضحة وجذابة وتعبر عن القيمة المقدمة.'
              delay={0.2}
              className="mb--2"
            />
            <FeatureBox
              icon={faImages}
              title='صور أو فيديوهات داعمة'
              description='يمكن أن تساعد الوسائط المرئية في جذب انتباه الزوار وتوضيح الرسالة.'
              delay={0.4}
            />
          </div>
          <div className="col-lg-4 p-12 mb-5 mt-2">
            <motion.div
              ref={refImg}
              initial={{ opacity: 0, y: -50 }}
              animate={inViewImg ? { opacity: 1, y: 0 } : {}}
              transition={{ duration: 1 }}
              className='text-center'
            >
              <img className='img-fluid' src={img2} alt="المكونات الأساسية للمواقع الإلكترونية" />
            </motion.div>
          </div>
          <div className='col-lg-4 col-md-10 p-12'>
            <FeatureBox
              icon={faEnvelope}
              title='نموذج تواصل'
              description='يجب أن يحتوي النموذج على حقول بسيطة لملء المعلومات المطلوبة من الزوار.'
              delay={0.6}
            />
            <FeatureBox
              icon={faHandPointer}
              title='دعوة لاتخاذ إجراء (CTA)'
              description='يمكن أن تكون هذه الدعوة عبارة عن زر يحمل نصًا مثل "تسجيل الآن" أو "احصل على استشارتك المجانية".'
              delay={0.8}
            />
          </div>
        </div>
      </div>
    </div>
  );
}

export default Basiccomponents;
